module.exports = __webpack_public_path__ + "img/client-11.2193827d.webp";